import { AxiosResponse } from 'axios';
import api from '~/services/api';

import { UserInterface } from '@e3labs/isa-data-dictionary';

class ClientChecklistService {
  getListClientChecklist({ skip = 0, limit = 100, ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListClientChecklistCount({ ...rest }, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/questionary?isCount=true', {
      params: {
        ...rest
      },
      ...opts
    });
  }

  getByIdClientChecklist(id: string, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/questionary/${id}`, {
      ...opts
    });
  }

  getResponsesByIdClientChecklist(id: string, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/questionary/response/${id}`, { ...opts });
  }

  saveClientChecklist(data: any): Promise<AxiosResponse<any[] | null>> {
    return api.post('/questionary', data);
  }

  editClientChecklist({ id, data }: { id: string; data: any }): Promise<AxiosResponse<any[] | null>> {
    return api.put(`/questionary/${id}`, {
      ...data
    });
  }

  deleteClientChecklist(id: string): Promise<AxiosResponse<any[] | null>> {
    return api.put(`/questionary/${id}`, {
      inactive: true
    });
  }

  getSellers(): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {}
    });
  }
}

export default new ClientChecklistService();
